<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-export-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 18v4H8v20h32V22h-4v-4h6a2 2 0 012 2v24a2 2 0 01-2 2H6a2 2 0 01-2-2V20a2 2 0 012-2h6zm21 16a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h18zm0-8a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h18zM25.264 2.414l7.778 7.778a1 1 0 010 1.415l-1.415 1.414a1 1 0 01-1.414 0l-4.242-4.242-.071 12.218a1 1 0 01-.997.994l-1.894.006A1 1 0 0122.006 21v-.01l.072-12.564-4.593 4.595a1 1 0 01-1.414 0l-1.414-1.415a1 1 0 010-1.414l7.778-7.778a2 2 0 012.829 0z"/></svg>
</template>
<script>

export default {
  name: 'IconExportAlt',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
